// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>

<section class="box">
  <sub-header header="'Issue PDC'"></sub-header>

  <ng-form name="\$ctrl.headerForm">
    <table class="table pdc-table">
      <thead>
      <tr>
        <th>Number of checks</th>
        <th>First check number</th>
        <th>Checks type</th>
        <th>Bank</th>
        <th>BRSTN</th>
        <th>Account number</th>
        <th>Depository account</th>
        <th>&nbsp;</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <input
            required
            type="number"
            min="1"
            max="{{\$ctrl.validAmortizations.length}}"
            ng-model="\$ctrl.checksCount">
        </td>
        <td>
          <input
            required
            type="text"
            minlength="10"
            maxlength="10"
            ui-mask="9999999999"
            ng-model="\$ctrl.firstCheckNumber" />
        </td>
        <td>
          <select
            required
            ng-model="\$ctrl.checksClearingGroup"
            ng-options="group.value as group.label for group in \$ctrl.pdcClearingGroups"
            ng-change="\$ctrl.checkClearingGroupChanged()">
          </select>
        </td>
        <td>
          <selectize options="\$ctrl.banks"
                     config="\$ctrl.selectConfig"
                     ng-model="\$ctrl.bankId"
                     ng-required="\$ctrl.checksClearingGroup !== 'ON_US'"
                     ng-disabled="\$ctrl.checksClearingGroup === 'ON_US'">
          </selectize>
        </td>
        <td>
          <input
            required
            ng-disabled="\$ctrl.isOnUsAndNotDirectClearing"
            type="text"
            minlength="9"
            maxlength="9"
            ui-mask="999999999"
            ng-model="\$ctrl.brstn" />
        </td>
        <td>
          <input
            required
            ng-disabled="\$ctrl.isOnUsAndNotDirectClearing"
            type="text"
            minlength="12"
            maxlength="12"
            ui-mask="999999999999"
            ng-model="\$ctrl.accountNumber" />
        </td>
        <td>
          <select
            ng-if="\$ctrl.isOnUsAndNotDirectClearing"
            required
            ng-model="\$ctrl.depositoryAccountId"
            ng-options="a.id as a.accountName for a in \$ctrl.depositoryAccounts"
            ng-change="\$ctrl.depositoryAccountChanged()">
          </select>
          <span ng-if="\$ctrl.checksClearingGroup !== 'ON_US' || \$ctrl.isPchcDirectClearingEnabled">
            N/A
          </span>
        </td>
        <td>
          <button
            ng-disabled="\$ctrl.headerForm.\$invalid"
            type="button"
            class="btn btn-success"
            ng-click="\$ctrl.populate()">
            Populate
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </ng-form>

  <ng-form name="\$ctrl.pdcForm" ng-if="\$ctrl.pdcInputList && \$ctrl.pdcInputList.length > 0">
    <div class="alert">
      <span>Generated PDC amounts are taken from amortization amounts</span>
    </div>

    <table class="table pdc-list" >
      <thead>
      <tr>
        <th>Amort. No.</th>
        <th>Amort. date</th>
        <th>Amort. amount</th>
        <th>Amort. balance</th>
        <th>Check date</th>
        <th>Bank</th>
        <th class="micr">MICR</th>
        <th>Amount</th>
        <th>&nbsp;</th>
      </tr>
      </thead>
      <tbody>
      <tr ng-repeat="pdc in \$ctrl.pdcInputList | orderBy:'pdc.amortization.lineNumber'">
        <td>{{pdc.amortization.lineNumber}}</td>
        <td>{{pdc.amortization.dueDate | prettyDate}}</td>
        <td>{{pdc.amortization.amortizationAmount | nxCurrency}}</td>
        <td>{{pdc.amortization.amortizationBalance | nxCurrency}}</td>
        <td>
          <date
            ng-required="true"
            output-format="date"
            ng-model="pdc.checkDate">
          </date>
        </td>
        <td>
          <selectize options="\$ctrl.banks"
                     config="\$ctrl.selectConfig"
                     ng-model="pdc.bankId">
          </selectize>
        </td>
        <td class="micr">
          <input
            required
            type="text"
            ng-model="pdc.micrNumber"
            ui-mask="&#x2448;9999999999&#x2448;99999&#x2449;9999&#x2446;999999999999&#x2448;" />
        </td>
        <td>
          <cash
            ng-required="true"
            ng-model="pdc.amount"
            min="1.0"
            max="pdc.amortization.amortizationAmount">
          </cash>
        </td>
        <td>
          <button
            type="button"
            class="btn btn-danger"
            ng-click="\$ctrl.remove(pdc.amortization.id)">
            Remove
          </button>
        </td>
        <td></td>
      </tr>
      <tr class="pdc-list__summary">
        <td colspan="2">Summary</td>
        <td>{{ \$ctrl.totalAmortizationPdcAmount | nxCurrency }}</td>
        <td>{{ \$ctrl.totalAmortizationPdcBalance | nxCurrency }}</td>
        <td></td>
        <td></td>
        <td></td>
        <td>{{ \$ctrl.sumPdcAmounts() | nxCurrency }}</td>
        <td></td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </ng-form>

  <div class="clearfix"></div>

  <div class="summary-actions">
    <button
      type="button"
      class="btn btn-warning"
      ng-click="\$ctrl.redirectBack()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-success"
      ng-disabled="\$ctrl.pdcForm.\$invalid || !\$ctrl.pdcInputList || \$ctrl.pdcInputList.length < 1"
      ng-click="\$ctrl.issue()">
      Issue PDC
    </button>
  </div>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/pdc/issue/loan-issue-pdc.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;